import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { maskCardNumber } from "../../functions/mask";
import {
  floatToPercent,
  floatToPrice,
  isNumber,
} from "../../functions/price_functions";
import styles from "./index.module.css";
import {
  CardType,
  OrderIntegrationPlanType,
} from "../../contexts/OrderContext";
// icones
import visaLogo from "../../assets/images/visa.svg";
import ticketLogo from "../../assets/images/ticket.svg";
import masterCardLogo from "../../assets/images/masterCard.svg";
import redeLogo from "../../assets/images/rede.svg";
import aleloLogo from "../../assets/images/alelo.svg";
import americaExpressLogo from "../../assets/images/americanExpress.svg";
import eloLogo from "../../assets/images/elo.svg";
import hiperCardLogo from "../../assets/images/hipercard.svg";
import maestroLogo from "../../assets/images/maestro.svg";
import { MdAttachMoney } from "react-icons/md";
import { CiDiscount1 } from "react-icons/ci";
import PixImg from "../../assets/images/pix.png";

type Props = {
  cpfInNote: string;
  paymentType: any;
  paymentMethod: any;
  card?: CardType;
  total: number;
  freight: number;
  changePaymentValue: number;
  integrationPlanLocal?: OrderIntegrationPlanType;
  cupomDiscount?: string;
  paymentDiscount?: { type: string; discountValue: string } | null | undefined;
  installment?: number;
  installmentValue?: number;
  type?: string;
};

const InfoPurchase: FC<Props> = ({
  cpfInNote,
  paymentType,
  paymentMethod,
  card,
  total,
  freight,
  changePaymentValue,
  integrationPlanLocal,
  cupomDiscount,
  paymentDiscount,
  installment,
  installmentValue,
  type,
}) => {
  function typeIntegrationPayment(value: string, typePay: string = "") {
    switch (value) {
      case "card":
        return "Cartão de crédito - ";
      case "debit-card":
        return "Cartão de débito - ";
      default:
        return "";
    }
  }

  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const trunCat = (num: number, decimals: number) => {
    const formatter = Math.pow(10, decimals);
    const res = Math.floor(num * formatter) / formatter;
    return res;
  };

  function floatToPrice(value: number): string {
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function cardIcon(cardBrand: string, typePayment?: string) {
    if (typePayment && typePayment === "others") {
      return (
        <>
          <svg
            width="16"
            height="16"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M49.4863 20.9105C49.4863 19.0549 48.4396 17.4267 46.9118 16.5915C47.0757 16.1104 47.1708 15.6029 47.1708 15.0743C47.1708 13.832 46.6898 12.6689 45.8175 11.7967L35.3768 1.35597C33.5688 -0.45199 30.6296 -0.45199 28.8216 1.35597L21.0241 9.15346C11.5297 9.22218 2.51634 10.2425 0.481065 18.0241C0.142734 18.8329 0 19.832 0 20.9052V44.599C0 47.3004 2.20973 49.5101 4.91109 49.5101H44.5752C47.2766 49.5101 49.4863 47.3004 49.4863 44.599V37.6632H31.1582C28.4569 37.6632 26.2471 35.4535 26.2471 32.7521C26.2471 30.0507 28.4569 27.841 31.1582 27.841H49.4863V20.9052V20.9105ZM17.8258 12.3465L14.1782 15.9941H5.00096C7.09439 13.7421 11.1174 12.6478 17.8258 12.3465ZM18.6347 15.9941L31.0419 3.58685C31.6181 3.01062 32.5644 3.00534 33.1406 3.58685L43.5813 14.0275C43.8615 14.3077 44.0148 14.6778 44.0148 15.0743C44.0148 15.4179 43.8985 15.7351 43.6924 15.9941H18.64H18.6347Z"
              fill="#1B1B1B"
            />
            <path
              d="M27.7803 32.8365C27.7803 34.8348 29.4032 36.4578 31.4015 36.4578C33.3998 36.4578 35.0227 34.8348 35.0227 32.8365C35.0227 30.8383 33.3998 29.2153 31.4015 29.2153C29.4032 29.2153 27.7803 30.8383 27.7803 32.8365Z"
              fill="#1B1B1B"
            />
          </svg>
        </>
      );
    }

    switch (cardBrand.toLowerCase()) {
      case "visa":
        return (
          <img
            src={visaLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );

      case "mastercard":
        return (
          <img
            src={masterCardLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "americanexpress":
        return (
          <img
            src={americaExpressLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "elo":
        return (
          <img
            src={eloLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "hipercard":
        return (
          <img
            src={hiperCardLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "maestro":
        return (
          <img
            src={maestroLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "rede":
        return (
          <img
            src={redeLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "ticket":
        return (
          <img
            src={ticketLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "alelo":
        return (
          <img
            src={aleloLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "others":
        return (
          <>
            <svg
              width="16"
              height="16"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M49.4863 20.9105C49.4863 19.0549 48.4396 17.4267 46.9118 16.5915C47.0757 16.1104 47.1708 15.6029 47.1708 15.0743C47.1708 13.832 46.6898 12.6689 45.8175 11.7967L35.3768 1.35597C33.5688 -0.45199 30.6296 -0.45199 28.8216 1.35597L21.0241 9.15346C11.5297 9.22218 2.51634 10.2425 0.481065 18.0241C0.142734 18.8329 0 19.832 0 20.9052V44.599C0 47.3004 2.20973 49.5101 4.91109 49.5101H44.5752C47.2766 49.5101 49.4863 47.3004 49.4863 44.599V37.6632H31.1582C28.4569 37.6632 26.2471 35.4535 26.2471 32.7521C26.2471 30.0507 28.4569 27.841 31.1582 27.841H49.4863V20.9052V20.9105ZM17.8258 12.3465L14.1782 15.9941H5.00096C7.09439 13.7421 11.1174 12.6478 17.8258 12.3465ZM18.6347 15.9941L31.0419 3.58685C31.6181 3.01062 32.5644 3.00534 33.1406 3.58685L43.5813 14.0275C43.8615 14.3077 44.0148 14.6778 44.0148 15.0743C44.0148 15.4179 43.8985 15.7351 43.6924 15.9941H18.64H18.6347Z"
                fill="#1B1B1B"
              />
              <path
                d="M27.7803 32.8365C27.7803 34.8348 29.4032 36.4578 31.4015 36.4578C33.3998 36.4578 35.0227 34.8348 35.0227 32.8365C35.0227 30.8383 33.3998 29.2153 31.4015 29.2153C29.4032 29.2153 27.7803 30.8383 27.7803 32.8365Z"
                fill="#1B1B1B"
              />
            </svg>
          </>
        );

      case "pix":
        return (
          <img
            src={PixImg}
            style={{
              width: "14px",
              height: "auto",
            }}
            alt="Pix"
          />
        );

      default:
        return (
          <>
            <div
              style={{
                width: "32px",
                height: "auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <i
                className="fa fa-credit-card"
                style={{
                  color: "#3C9EE5",
                }}
              />
            </div>
          </>
        );
    }
  }

  return (
    <div className={styles.content}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h4>Pagamento</h4>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "14px",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/${pluginspace_id}/new-choose-payment`)}
        >
          <span style={{ color: "#37393D" }}>Trocar</span>
          <i className="fas fa-pen" style={{ fontSize: "12px" }}></i>
        </div>
      </div>
      <div className={styles.finalize_order_details}>
        {paymentType && (
          <>
            <div className={styles.info_card} style={{ gap: "4px" }}>
              {paymentType.includes("card") && cardIcon(card ? card.brand : "")}
              <p>
                <b>{paymentType.includes("card") && "Cartão de crédito: "}</b>
                {paymentType.includes("card") &&
                  card?.number &&
                  maskCardNumber(card.number)}
                {paymentMethod}
              </p>
            </div>
            <p>
              <b>{paymentType.includes("card") && "Parcelas: "}</b>
              {paymentType.includes("card") &&
                card?.installments &&
                `${card.installments}x ${floatToPrice(
                  (total + freight) / parseInt(card.installments)
                )}`}
              {paymentMethod}
            </p>

            <p>
              {paymentType.includes("delivery-payment") && (
                <>
                  {integrationPlanLocal && !paymentType.includes("card") && (
                    <div className={styles.info_card}>
                      {cardIcon(
                        integrationPlanLocal.nameBrand
                          ? integrationPlanLocal.nameBrand
                          : "",
                        integrationPlanLocal.typePayment
                      )}
                      <p>
                        {typeIntegrationPayment(
                          integrationPlanLocal.typePayment,
                          integrationPlanLocal?.paymentItemData?.typePay
                        )}{" "}
                        {integrationPlanLocal.nameBrand}
                      </p>
                    </div>
                  )}
                  <p>
                    {"Método: "}
                    Pagamento na entrega
                  </p>
                  {integrationPlanLocal &&
                    (integrationPlanLocal.typePayment === "card" ||
                      integrationPlanLocal.typePayment === "others") && (
                      <p>
                        {"Parcelas: "} {installment || 1}x{" "}
                        {floatToPrice(trunCat(installmentValue || 0, 2))}
                      </p>
                    )}
                </>
              )}
              {(paymentType.includes("pix") ||
                paymentType.includes("wallet") ||
                paymentType.includes("shipay")) && (
                <>
                  <p>{"Método: "}PIX</p>
                  <p>
                    {"Parcelas: "} 1x {floatToPrice(total + freight)}
                  </p>
                </>
              )}
            </p>

            {isNumber(changePaymentValue) &&
              changePaymentValue > 0 &&
              integrationPlanLocal &&
              integrationPlanLocal.nameBrand &&
              integrationPlanLocal.nameBrand === "Dinheiro" && (
                <p>
                  {"Troco para: "}{" "}
                  {floatToPrice(changePaymentValue + total + freight)}
                </p>
              )}

            {paymentDiscount &&
              paymentDiscount.discountValue &&
              paymentDiscount.type && (
                <p
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  Desconto por Meio de Pagamento :{" "}
                  <b>
                    {" "}
                    {paymentDiscount.type === "percentage"
                      ? floatToPercent(
                          parseFloat(paymentDiscount.discountValue)
                        )
                      : floatToPrice(
                          parseFloat(paymentDiscount.discountValue)
                        )}{" "}
                  </b>
                  <CiDiscount1 size="20px" color="#6E7586" />
                </p>
              )}

            {cupomDiscount && (
              <p style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                Cupom: <b> {cupomDiscount} </b>{" "}
                <CiDiscount1 size="20px" color="#6E7586" />
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export { InfoPurchase };
